import React from 'react'
import gql from 'graphql-tag'
import styles from './styles.css'
import PropTypes from 'prop-types'
import { Field } from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import Int from 'App/components/fields/Int'

@withGraphQL(gql`
  query products {
    products {
      productCode
      description
      price
    }
  }
`)
export default class ProductField extends React.Component {
  static propTypes = {
    products: PropTypes.object,
    codigo: PropTypes.string,
    productData: PropTypes.func,
    // oneTotalPrice: PropTypes.func,
    // productPrice: PropTypes.func,
    index: PropTypes.number
  }

  options() {
    let options = []
    const products = this.props.products
    products.map(product => {
      options.push({ label: product.productCode, value: product.productCode })
      return null
    })
    return options
  }

  render() {
    const index = this.props.index
    const products = this.props.products
    return (
      <div className={styles.container}>
        Código del producto
        <Field
          className={styles.code}
          placeholder="Selecciona el código del producto"
          fieldName="codigo"
          type={Select}
          options={this.options()}
          onChange={value => this.props.productData(value, index, products)}
        />
        Descripción del producto
        <Field
          placeholder="Agregar descripción."
          fieldName="description"
          type={Text}
        />
        Precio unitario del producto
        <div className={styles.field}>
          <Field
            fieldName="price"
            type={Int}
            // onChange={value => this.props.productPrice(value, index)}
          />
        </div>
        Cantidad de productos
        <div className={styles.field}>
          <Field
            placeholder="Ingrese la cantidad de productos"
            fieldName="amount"
            type={Int}
            // onChange={value => this.props.oneTotalPrice(value, index, products)}
          />
        </div>
        Total (Cantidad por precio unitario)
        <div className={styles.field}>
          <Field fieldName="total" type={Int} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/ProductField/index.js